// Supabase answers at most 1000 rows per request, so long exports are read page by page.
export const PAGE_SIZE = 1000

type PageResult<T> = { data: T[] | null; error: unknown }

// `fetchPage` must use a stable order (a date alone has ties) so pages neither overlap nor skip rows.
export const fetchAllPages = async <T>(
    fetchPage: (from: number, to: number) => PromiseLike<PageResult<T>>,
    pageSize = PAGE_SIZE,
): Promise<T[]> => {
    const rows: T[] = []
    for (;;) {
        const { data, error } = await fetchPage(rows.length, rows.length + pageSize - 1)
        if (error) throw error
        // Stop on an empty page rather than a short one: the server may cap pages below pageSize.
        if (!data || data.length === 0) return rows
        rows.push(...data)
    }
}
